<script lang="ts">
  export let href: string
  export let label: string
</script>

<a
  href={href}
  target="_blank"
  aria-label={label}
>
  {label}
</a>

<style>
  a, a:visited {
    font-size: 10px;
    line-height: 16px;
    color:  #747486;
    margin-left: 12px;
    font-family: canada-type-gibson;
  }
</style>
